/*
 * @Desc: 
 * @Author: wanglidong 王立冬
 * @Date: 2023-05-19 11:00:36
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-05-30 16:54:44
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
 */
import request from '@/utils/request'

export function fetchList(query) {
  return request({
    url: '/menu/tree',
    method: 'get',
    params: query
  })
}

export function fetchPermission(id) {
  return request({
    url: '/menu/detail',
    method: 'post',
    params: { id }
  })
}

export function createPermission(data) {
  return request({
    url: '/menu/create',
    method: 'post',
    data
  })
}

export function updatePermission(data) {
  return request({
    url: '/menu/edit',
    method: 'post',
    data
  })
}

export function delPermission(data) {
  return request({
    url: '/menu/remove',
    method: 'post',
    data
  })
}

export function sort(data) {
  return request({
    url: '/menu/sort',
    method: 'post',
    data
  })
}
